import axios from 'axios'
import history from './history'
import { getCurrentTime, getQueryString } from './utils'
import { Toast } from 'antd-mobile'
import ownObserver from '@/utils/observer'
import bridgeObj from './bridge'

const sendErrorMsg = (msg) => {
  ownObserver.onlyemit('saveErrorMsg', msg)
}

const CryptoJS = require('crypto-js')

let cancelFlag = false

const service = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 50000
})

service.interceptors.request.use(
  (config) => {

    let token = localStorage.getItem('token')
    if (token) config.headers['Authorization'] = token

    let timestamp = getCurrentTime()
    let sign = CryptoJS.SHA256(`${process.env.REACT_APP_SIGN_KEY}.${timestamp}.${process.env.REACT_APP_SIGN_SECRET}.${JSON.stringify(config.data)}`).toString()

    config.headers = {
      ...config.headers,
      timestamp,
      sign,
      site: 'h5',
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptors
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (response.request.responseType === 'text') return response
    if (res.success || (response.request.responseType === 'blob' && response.status === 200)) return response
    // errorMsg(res.message || '未知错误')
    if (res.code === '9999999996') {
      console.log('登录-返回code9999999996', response, service)
      history.push('/login')
      Toast.show(res.message)
    }
    if (res.code === '1700000016') {
      Toast.show(res.message)
    }
    if (res.code === '100004525') {
      Toast.show(res.message)
    }
    return Promise.reject(res || '未知错误')
  },
  (error) => {
    console.log(error.response, 'error')
    if (error.response && error.response.status === 401) {
      if (cancelFlag) return Promise.reject(error)
      cancelFlag = true
      Toast.show({ content: error.response.data, maskClickable: false })
      sendErrorMsg(error.response.data)
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('userPersonaInfo')
      // window.localStorage.removeItem('userRousebyLiveData')
      setTimeout(() => {
        if (localStorage.getItem('h5_platform') === 'BoaoApp') {
          localStorage.removeItem('h5_platform')
          bridgeObj.callhandler('tokenOutOfDate', error.response.data, () => {})
        } else {
          console.log('401')
          if (window.localStorage.getItem('h5_securitySite')) {
            console.log(getQueryString('redirect_url'))
            console.log('登录-401', window.localStorage.getItem('h5_securitySite'))
            history.push(`/login?redirect_url=${getQueryString('redirect_url')}&securitySite=${getQueryString('securitySite')}`)
          } else {
            console.log('登录-401未获取h5_securitySite',  error.response, service)
            history.push('/login')
          }
        }
      }, 2000)
      setTimeout(() => {
        cancelFlag = false
      }, 1000)
    }
    return Promise.reject(error)
  }
)

const getCancelToken = () => {
  let { CancelToken } = axios
  let source = CancelToken.source()
  return source
}

export default service

export { getCancelToken }
